import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import type { AuthMeResponse } from "@memes/shared";
import { authApi } from "../lib/api";

export const AUTH_KEY = ["auth", "me"] as const;

export function useAuthMe() {
  return useQuery({
    queryKey: AUTH_KEY,
    queryFn: () => authApi.me(),
    retry: false,
    staleTime: 60_000,
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => authApi.logout(),
    onSuccess: () => {
      qc.setQueryData<AuthMeResponse>(AUTH_KEY, {
        authenticated: false,
        authRequired: true,
        user: null,
      });
    },
  });
}
